import { EDiscountStatus, IDiscount } from 'models/discounts'
import { Tag } from 'antd'
import dayjs from 'dayjs'

interface IDiscountStatusItemData {
  key: EDiscountStatus
  label: React.ReactNode
}

export const discountsStatuses = {
  [EDiscountStatus.ACTIVE]: {
    value: EDiscountStatus.ACTIVE,
    label: 'Активна',
    color: 'green'
  },
  [EDiscountStatus.SCHEDULED]: {
    value: EDiscountStatus.SCHEDULED,
    label: 'Запланирована',
    color: 'blue'
  },
  [EDiscountStatus.EXPIRED]: {
    value: EDiscountStatus.EXPIRED,
    label: 'Истекла',
    color: 'default'
  },
  [EDiscountStatus.ARCHIVED]: {
    value: EDiscountStatus.ARCHIVED,
    label: 'Архив',
    color: 'red'
  }
}

const activeStatus: IDiscountStatusItemData = {
  key: EDiscountStatus.ACTIVE,
  label: (
    <Tag color={discountsStatuses[EDiscountStatus.ACTIVE].color}>
      {discountsStatuses[EDiscountStatus.ACTIVE].label}
    </Tag>
  )
}

const archivedStatus: IDiscountStatusItemData = {
  key: EDiscountStatus.ARCHIVED,
  label: (
    <Tag color={discountsStatuses[EDiscountStatus.ARCHIVED].color}>
      {discountsStatuses[EDiscountStatus.ARCHIVED].label}
    </Tag>
  )
}

// В базе только ACTIVE и ARCHIVED: истёкшая и запланированная — это ACTIVE по датам
export const getDiscountDisplayStatus = (
  discount: Pick<IDiscount, 'status' | 'isExpired' | 'isScheduled'>
): EDiscountStatus => {
  if (discount.status !== EDiscountStatus.ACTIVE) return discount.status
  if (discount.isExpired) return EDiscountStatus.EXPIRED
  if (discount.isScheduled) return EDiscountStatus.SCHEDULED
  return EDiscountStatus.ACTIVE
}

export const getDiscountStatusLabel = (
  status: EDiscountStatus,
  startDate?: string
): string => {
  const { label } = discountsStatuses[status]
  return status === EDiscountStatus.SCHEDULED && startDate
    ? `${label} с ${dayjs(startDate).format('DD.MM')}`
    : label
}

// EXPIRED и SCHEDULED вычисляются по датам и вручную не назначаются
export const getDiscountsStatusItems = (
  status: EDiscountStatus
): IDiscountStatusItemData[] => {
  if (status === EDiscountStatus.ACTIVE || status === EDiscountStatus.SCHEDULED) {
    return [archivedStatus]
  }
  if (status === EDiscountStatus.ARCHIVED || status === EDiscountStatus.EXPIRED) {
    return [activeStatus]
  }
  return []
}
